import "core-js/modules/es6.array.map";
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import cloneDeep from 'lodash/cloneDeep';
/**
 * @private
 * @param http - HTTP client instance
 * @param data - Raw data
 * @return Normalized user
 */

export function wrapUser(http, data) {
  var user = toPlainObject(cloneDeep(data));
  enhanceWithMethods(user, {});
  return freezeSys(user);
}
/**
 * @private
 * @param http - HTTP client instance
 * @param data - Raw data collection
 * @return Normalized user collection
 */

export function wrapUserCollection(http, data) {
  var users = toPlainObject(cloneDeep(data));
  users.items = users.items.map(function (entity) {
    return wrapUser(http, entity);
  });
  return freezeSys(users);
}